import Handsontable from 'handsontable/base';
import { CellSelections } from '../../../../../../common/table/TableTypes';
import { getAllCellsBetween } from '../tableCellSelectionUtils';

/**
 * This function is used to set the *temporary* cell color (for now, see to-do below) when the user is
 * using the custom color picker because it can update many times very quickly, for that reason we
 * are updating the hotTable instance directly to render the new colour, but not saving to redux
 *
 * TODO-TABLE-SYNC - Determine whether this can be the standard way that the table colour gets updated,
 *   rather than having to do it via the main store
 */
export const setHotTableCellBackgroundColor = (
    hotInstance: Handsontable | null | undefined,
    cellSelections: CellSelections | undefined = hotInstance?.getSelected(),
    backgroundColor: string | null,
) => {
    if (!hotInstance) return;

    if (!cellSelections) return;

    getAllCellsBetween(cellSelections).forEach((cell) => {
        const { row, col } = cell;
        const currentCellData = hotInstance.getCellMeta(row, col)?.cellData || {};
        hotInstance.setCellMetaObject(row, col, {
            cellData: { ...currentCellData, background: backgroundColor },
        });
    });

    hotInstance.render();
};
